'use client';

import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

const Content = () => {
  const t = useTranslations();

  return (
    <>
      <TypographyV3 Element="h1" variant="h3" className="mb-8">
        {t('impressum_page_title')}
      </TypographyV3>

      <ul>
        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_business_name')}:
          </TypographyV3>
          <TypographyV3 Element="span">Oura Health Oy</TypographyV3>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_business_address')}:
          </TypographyV3>
          <TypographyV3 Element="span" className="block">
            Elektroniikkatie 10, 90590 Oulu
          </TypographyV3>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_phone_number')}:
          </TypographyV3>
          <TypographyV3 Element="span" className="block">
            +358 102816446
          </TypographyV3>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_email_address')}:
          </TypographyV3>
          <TypographyV3 Element="span" className="block">
            <a href="mailto:info@ouraring.com">info@ouraring.com</a>
          </TypographyV3>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_registration_number')}:
          </TypographyV3>
          <TypographyV3 Element="span" className="block">
            2542776-4
          </TypographyV3>
        </div>

        <div className="mb-4 md:flex md:flex-wrap md:gap-2">
          <TypographyV3 Element="span" className="block font-bold">
            {t('impressum_label_vat_id_number')}:
          </TypographyV3>
          <TypographyV3 Element="span" className="block">
            FI25427764
          </TypographyV3>
        </div>
      </ul>
    </>
  );
};

export default Content;
